import type { TFunction } from 'i18next';

import formatCurrency from '@/lib/utils/formatCurrency';

export const formatPremiumWithInterval = (
  premium: Maybe<number>,
  interval: Maybe<string>,
  t: TFunction,
): string | undefined => {
  const amount = formatCurrency(premium);
  if (!amount) return undefined;
  if (!interval) return amount;

  const keyMap: Record<string, string> = {
    MONTHLY: 'PAYMENT_INTERVAL_MONTHLY',
    ANNUAL: 'PAYMENT_INTERVAL_ANNUAL',
    QUARTERLY: 'PAYMENT_INTERVAL_QUARTERLY',
    HALF_ANNUAL: 'PAYMENT_INTERVAL_HALF_ANNUAL',
    ONCE: 'PAYMENT_INTERVAL_ONCE',
  };

  const normalized = interval.toUpperCase();
  const key = keyMap[normalized];
  if (!key) return amount;

  return `${amount} / ${t(key)}`;
};

export const dueDateToReadable = (dateString: Maybe<string>) => {
  if (!dateString) return undefined;

  const [month, day] = dateString?.split('-');

  return `${day}/${month}`;
};
